import React from 'react';
import PropTypes from 'prop-types';
import { Button, Form } from 'react-bootstrap';
import LinkComponent from '../core/LinkComponent/LinkComponent';
import ReactGA from 'react-ga';

import FieldGroupComponent from '../core/FieldGroupComponent/FieldGroupComponent';
import LoadingComponent from '../core/LoadingComponent/LoadingComponent';

import './login.scss';

class SignInComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            staySignedIn: false,
        };
    }

    changeStay = () => {
        this.setState({
            staySignedIn: !this.state.staySignedIn,
        });
    }

    componentDidMount() {
        window.location.search && window.history.replaceState(null, '', window.location.pathname);
        ReactGA.set({ page: window.location.pathname });
        ReactGA.set({ title: 'Sign In Page' });
        ReactGA.pageview(window.location.pathname);
    }

    handleSubmit = () => {
        ReactGA.event({
            category: 'Sign In Component',
            action: 'Clicked Login',
            label: 'Button',
        });
    }

    onGoToSignUp = () => {
        const { onGoToSignUp } = this.props;
        ReactGA.event({
            category: 'Sign In Component',
            action: 'Clicked Sign Up',
            label: 'Button',
        });
        onGoToSignUp();
    }

    render() {
        const { handleSubmit, submitting } = this.props;
        const { staySignedIn } = this.state;

        return <div className="login container">
            {submitting && <LoadingComponent fullScreen />}
            <h2>Log In</h2>
            <Form onSubmit={handleSubmit}>
                <FieldGroupComponent
                    label="Email"
                    name="email"
                    type="text"
                />
                <FieldGroupComponent
                    label="Password"
                    name="password"
                    type="password"
                    className="password-field"
                />
                <LinkComponent url="/reset-password" title="Forgot Password?" className="forgot-pass-text" />
                <FieldGroupComponent
                    name="staySignedIn"
                    type="checkbox"
                    placeholder="Stay Signed In"
                    onChange={this.changeStay}
                    checked={staySignedIn}
                />
                <div className="buttons">
                    <Button type="submit" className="next" onClick={this.handleSubmit}>Log In</Button>
                </div>
                <div className="divider">
                    <hr className="left" />
                    <span>Or</span>
                    <hr className="right" />
                </div>
                <Button className="tertiary" onClick={this.onGoToSignUp}>Sign Up</Button>
            </Form>
        </div>;
    }
}

SignInComponent.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onGoToSignUp: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
};

export default SignInComponent;



// WEBPACK FOOTER //
// ./src/components/login/SignInComponent.js